import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType  } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { newsletterTemplateColorsEdit_template } from "../components/templates/newsletterTemplateColorsEdit_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { header } from "./header";

declare var ko: any;
declare var page: any;

export class newsletter_template_colors_edit extends vnModule_knockoutJS{
    protected newsletterTemplateColorsEdit!: newsletterTemplateColorsEdit_template;
    protected XHRHdl!: XMLHttpRequestHandler;
    protected _isLeavePageWarningNeeded: boolean = true;

    buildContent(): Array<Element> {
        this.newsletterTemplateColorsEdit = new newsletterTemplateColorsEdit_template('newsletterTemplateColorsEdit', this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader!.loadedModule;
        (<header>loadedModule).setHeaderTitle("Newsletter Header Color");
        return [this.newsletterTemplateColorsEdit.build()]
    }

    protected getModuleName(): string {
        return "newsletter_template_colors_edit";
    }

    public fillPage() {
        this.getHeaderColorData();
    }

    private getHeaderColorData() {
        let id = this.getVnAppZone().app.params.id;
        if (!id) {
            return;
        }

        this.loadingIn(this.newsletterTemplateColorsEdit.builtTemplate);

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let url : string = '/api/brand/' + idBrand + '/newsletter/templates/colors/get/' + id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetHeaderColorDataReturn;
        this.XHRHdl.execute();
    }

    private onGetHeaderColorDataReturn(req: any, obj: any) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.newsletterTemplateColorsEdit.setHeaderColor(responseParsed.data)

            });
            obj.loadingOut(obj.newsletterTemplateColorsEdit.builtTemplate);
        }
    }

    public onClickCancelEdit(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/templates/colors/")
    }

    protected save() {
        this.validationTemplate.clearMessages();

        let subViewModel = this.newsletterTemplateColorsEdit.getViewModelForRequest();
        let validationMessages = this.getValidationMessages(subViewModel);
        if (validationMessages.length > 0) {
            this.validationTemplate.setMessages(validationMessages);
            window.scrollTo(0, 0);
            return;
        }

        this.loadingIn(this.newsletterTemplateColorsEdit.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/newsletter/templates/colors/save/";
        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req: any, obj: any) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    page.redirect('/brand/' + idBrand + "/newsletter/templates/colors/");

                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Header Color saved !");
                    }
                });
                obj.loadingOut(obj.newsletterTemplateColorsEdit.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    private getValidationMessages(data: any): any[] {
        let errors = [];
        let color = String(data.color || '').trim();

        if (!data.name) {
            errors.push({field: "Name", label: "Name", messages: ["Name cannot be empty."]});
        }

        if (!color) {
            errors.push({field: "Color", label: "Color", messages: ["Color cannot be empty."]});
        }

        if (color && (!/^#[0-9a-fA-F]{6}$/.test(color))) {
            errors.push({field: "Color", label: "Color", messages: ["Color must be a valid hexadecimal value."]});
        }

        return errors;
    }
}



// WEBPACK FOOTER //
// ./js/modules/newsletter_template_colors_edit.ts